import { Box, SxProps } from '@mui/material';
import { Outlet } from '@tanstack/react-router';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: 'primary.light',
  },
} satisfies Record<string, SxProps>;

export const PublicLayout = () => {
  return (
    <Box sx={styles.container}>
      <Outlet />
    </Box>
  );
};
